// Actor Awards card game data with rankings
export const ACTOR_AWARDS_CARDS = [
  { id: 1, name: "Meryl Streep", rank: 1 ,
    image: "/images/actorAwards/actorAwards_1.jpg"
  },
  { id: 2, name: "Katharine Hepburn", rank: 2 ,
    image: "/images/actorAwards/actorAwards_2.jpg"
  },
  { id: 3, name: "Jack Nicholson", rank: 3 ,
    image: "/images/actorAwards/actorAwards_3.jpg"
  },
  { id: 4, name: "Bette Davis", rank: 4 ,
    image: "/images/actorAwards/actorAwards_4.jpg"
  },
  { id: 5, name: "Laurence Olivier", rank: 5 ,
    image: "/images/actorAwards/actorAwards_5.jpg"
  },
  { id: 6, name: "Spencer Tracy", rank: 6 ,
    image: "/images/actorAwards/actorAwards_6.jpg"
  },
  { id: 7, name: "Denzel Washington", rank: 7 ,
    image: "/images/actorAwards/actorAwards_7.jpg"
  },
  { id: 8, name: "Paul Newman", rank: 8 ,
    image: "/images/actorAwards/actorAwards_8.jpg"
  },
  { id: 9, name: "Al Pacino", rank: 9 ,
    image: "/images/actorAwards/actorAwards_9.jpg"
  },
  { id: 10, name: "Cate Blanchett", rank: 10 ,
    image: "/images/actorAwards/actorAwards_10.jpg"
  },
  { id: 11, name: "Marlon Brando", rank: 11 ,
    image: "/images/actorAwards/actorAwards_11.jpg"
  },
  { id: 12, name: "Robert De Niro", rank: 12 ,
    image: "/images/actorAwards/actorAwards_12.jpg"
  },
  { id: 13, name: "Jack Lemmon", rank: 13 ,
    image: "/images/actorAwards/actorAwards_13.jpg"
  },
  { id: 14, name: "Judi Dench", rank: 14 ,
    image: "/images/actorAwards/actorAwards_14.jpg"
  },
  { id: 15, name: "Geraldine Page", rank: 15 ,
    image: "/images/actorAwards/actorAwards_15.jpg"
  },
  { id: 16, name: "Glenn Close", rank: 16 ,
    image: "/images/actorAwards/actorAwards_16.jpg"
  },
  { id: 17, name: "Peter O'Toole", rank: 17 ,
    image: "/images/actorAwards/actorAwards_17.jpg"
  },
  { id: 18, name: "Ingrid Bergman", rank: 18 ,
    image: "/images/actorAwards/actorAwards_18.jpg"
  },
  { id: 19, name: "Jane Fonda", rank: 19 ,
    image: "/images/actorAwards/actorAwards_19.jpg"
  },
  { id: 20, name: "Dustin Hoffman", rank: 20 ,
    image: "/images/actorAwards/actorAwards_20.jpg"
  },
  { id: 21, name: "Jeff Bridges", rank: 21 ,
    image: "/images/actorAwards/actorAwards_21.jpg"
  },
  { id: 22, name: "Robert Duvall", rank: 22 ,
    image: "/images/actorAwards/actorAwards_22.jpg"
  },
  { id: 23, name: "Greer Garson", rank: 23 ,
    image: "/images/actorAwards/actorAwards_23.jpg"
  },
  { id: 24, name: "Kate Winslet", rank: 24 ,
    image: "/images/actorAwards/actorAwards_24.jpg"
  },
  { id: 25, name: "Richard Burton", rank: 25 ,
    image: "/images/actorAwards/actorAwards_25.jpg"
  },
  { id: 26, name: "Daniel Day-Lewis", rank: 26 ,
    image: "/images/actorAwards/actorAwards_26.jpg"
  },
  { id: 27, name: "Frances McDormand", rank: 27 ,
    image: "/images/actorAwards/actorAwards_27.jpg"
  },
  { id: 28, name: "Michael Caine", rank: 28 ,
    image: "/images/actorAwards/actorAwards_28.jpg"
  },
  { id: 29, name: "Tom Hanks", rank: 29 ,
    image: "/images/actorAwards/actorAwards_29.jpg"
  },
  { id: 30, name: "Anthony Hopkins", rank: 30 ,
    image: "/images/actorAwards/actorAwards_30.jpg"
  }
];
